<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M39.06 8.94a1.5 1.5 0 010 2.12L13.622 36.5H30a1.5 1.5 0 010 3H10A1.5 1.5 0 018.5 38V18a1.5 1.5 0 013 0v16.379l25.44-25.44a1.5 1.5 0 012.12 0z"/></svg>